






























































































































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from '@nuxtjs/composition-api';
import {
  SfButton,
  SfCharacteristic,
  SfModal,
  SfSelect,
} from '@storefront-ui/vue';

import { useCurrency } from '~/composables';

export default defineComponent({
  name: 'SelectWebsitePop',
  components: {
    SfModal,
    SfButton,
    SfSelect,
    SfCharacteristic,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: () => true,
    },
    websiteDefaultValue: {
      type: String,
      default: () => '',
    },
    currencyDefaultValue: {
      type: String,
      default: () => '',
    },
  },
  setup(props) {
    const websiteValue = ref<any>();
    const currencyValue = ref<any>();

    const site = [
      {
        id: 1,
        siteValue: 'gb',
        siteName: 'United Kingdom',
        icon: 'gb',
        link: 'https://www.unineed.com/',
      },

      {
        id: 2,
        siteValue: 'us',
        siteName: 'United States',
        icon: 'us',
        link: 'https://us.unineed.com/',
      },
      {
        id: 3,
        siteValue: 'mex',
        siteName: 'Mexico',
        icon: 'mex',
        link: 'https://mx.unineed.com/',
      },
    ];

    const handleChangeWebsite = (value: any) => {
      websiteValue.value = value;
    };
    const handleChangeCurrency = (value: any) => {
      currencyValue.value = value;
    };
    const save = () => {
      if (websiteValue.value) {
        const url = websiteValue.value;
        const params = new URLSearchParams({
          currency: currencyValue.value,
        });
        if (currencyValue.value) {
          window.location.replace(`${url}?${params.toString()}`);
        } else {
          window.location.replace(`${url}`);
        }

        // window.open(`${url}?${params.toString()}`, '_blank');
      }
    };
    const { currency: currencies, load: loadCurrencies } = useCurrency();
    const availableCurrencies = computed<string[]>(
      () => currencies.value?.available_currency_codes || []
    );
    // 监视 props 的变化
    watch(
      () => props.currencyDefaultValue,
      (newVal) => {
        currencyValue.value = newVal;
        console.log(currencyValue.value, 'currencyValue');
      }
    );
    watch(
      () => props.websiteDefaultValue,
      (newVal) => {
        websiteValue.value = newVal;
        console.log(websiteValue.value, 'websiteValue');
      }
    );

    onMounted(() => {
      if (currencies.value && currencies.value?.available_currency_codes) {
        return;
      }
      loadCurrencies();
    });

    return {
      site,
      websiteValue,
      currencyValue,
      handleChangeWebsite,
      availableCurrencies,
      handleChangeCurrency,
      save,
    };
  },
});
